import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, OnDestroy, ViewChild, SimpleChanges, OnChanges, OnInit } from '@angular/core';

import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { EspacioFormulario, EspacioIdiomaFormulario } from '../domain/EspacioFormulario';
import * as allSettled from 'promise-all-settled';
import { TranslateService } from 'ng2-translate';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import {
	Predicate
} from 'breeze-client';
import { Idioma } from '../domain/Idioma';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';
import { AppComponent } from '../app.component';
import { PermisosService, Permisos } from '../providers/authentication/permisos.service';

@Component({
	selector: 'app-formulario-espacio',
	templateUrl: './FormularioEspacio.component.html',
	providers: [MessageService]
})


export class FormularioEspacioComponent implements OnDestroy, OnChanges, OnInit { //  extends FormGroup { // extends FormularioBaseComponent<ALA> {

	@Input() mapEspacioIdioma: Map<String, EspacioFormulario>; // Mapa con la misma noticia pero en distintos idiomas.

	@Input() espacioSeleccionado: EspacioFormulario = new EspacioFormulario();
	@Input() edicion: boolean;
	@Input() limpiarImagen: boolean;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<any> = new EventEmitter();
	@Output() onFormularioValidation: EventEmitter<boolean> = new EventEmitter();

	msgs: Message[] = [];
	spinner: HTMLElement;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	imagenSeleccionada: any;
	selectorImagenEspacio: any;

	public fAltaError = false;
	public fBajaError = false;

	public pantallaPrincipalError = false;

	public isValid = true;
	public nombreError = false;
	public imagenError = false;
	public confirmacionVisible = false;
	public operacion = '';

	/* IMAGE CROPPER*/
	data: any;
	cropperSettings: CropperSettings;
	imageCropperVisible = false;

	@ViewChild('cropper', undefined)
	cropper: ImageCropperComponent;
	permisos: Permisos;
	PantallaPrincipal: any;
	constructor(
	private appComponent: AppComponent,
	private entityManager: EntityManagerProvider,
	public authService: AuthenticationService,
	private messageService: MessageService,
	public sws: ServiciosWebServiceProvider,
	private idiomaService: IdiomaService,
	private translate: TranslateService,
	private permisosService: PermisosService)
	{

			this.cropperSettings = new CropperSettings();
			this.cropperSettings.width = 400;
			this.cropperSettings.height = 400;
			this.cropperSettings.croppedWidth = 400;
			this.cropperSettings.croppedHeight = 400;
			this.cropperSettings.canvasWidth = 400;
			this.cropperSettings.canvasHeight = 400;
			this.cropperSettings.noFileInput = true;
			this.cropperSettings.fileType = "image/webp";
			this.cropperSettings.minWithRelativeToResolution = true;

			this.data = {};
			// Inicializamos Spinner
			this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
			this.spinner.style.display = 'none';

			const that = this;
			this.entityManager.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {

				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;


				return that.comprobarPermisos();
			})
			.then(function (perm) {
				// Permisos ok
			});


			this.idiomaCalendario = new IdiomaCalendario();
			this.idiomaCalendario.firstDayOfWeek = 1;
			this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
			this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
			this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
			this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
			this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
			this.idiomaCalendario.today = this.translate.instant('Calendario.today');
			this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

			this.PantallaPrincipal = [
				{label: 'Mapa', value: 0},
				{label: 'Ruta Sugerida', value: 1}
			];

	}

	ngOnInit(){
		this.data = {};
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.confirmacionVisible = false;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
	}

	ngOnDestroy(): void {
		this.data = {};
		this.entityManager.RejectChanges();
	}

	onFileSelect($event, fileUploadComponent) {
		this.selectorImagenEspacio = fileUploadComponent;
		this.imagenSeleccionada = $event.files[0];
	}

	onRemoveSelect($event?, fileUploadComponent?) {
		this.imagenSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
		this.onRemoveSelect();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
			return perm;
		});
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/* Validacion */
	inputChanged(value) {
		const p1Error = this.espacioSeleccionado === undefined || this.espacioSeleccionado.Nombre === '';
		const p2Error = this.espacioSeleccionado.Imagen === undefined && this.imagenSeleccionada === undefined && this.espacioSeleccionado.ENTIDAD.Imagen === undefined;
		const p3Error = this.espacioSeleccionado.FechaAlta === undefined || this.espacioSeleccionado.FechaAlta === null;
		const p4Error = false; // this.rutaSeleccionada.FechaBaja === ''  || this.rutaSeleccionada.FechaBaja === undefined  || this.rutaSeleccionada.FechaBaja === null
		const p5Error = false;
		const p6Error = this.espacioSeleccionado.PantallaPrincipal === undefined;


		// Validacion al guardar
		if (value === 'obligatorio') {
			if (p1Error) {
				this.nombreError = true;
			}
			else {
				this.nombreError = false;
			}

			if (p2Error) {
				this.imagenError = true;
			}
			else {
				this.imagenError = false;
			}
			if (p3Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
			if (p4Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
			if (p6Error) {
				this.pantallaPrincipalError = true;
			}
			else {
				this.pantallaPrincipalError = false;
			}
		}
		if (value === 'nombre') {
			if (this.espacioSeleccionado.Nombre === '') {
				this.nombreError = true;
			}
			else {
				this.nombreError = false;
			}
		}
		// validacion al editar fecha_alta
		if (value === 'fecha_alta'){
			if (p3Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		// validacion al editar fecha_baja
		if (value === 'fecha_baja'){
			if (p4Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}
		if(value === 'anonimo'){
			if (p5Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}
		if(value === 'pantallaPrincipal'){
			// Siempre que entra aqui es por que se ha seleccionado una pantalla principal, si o si
			this.pantallaPrincipalError = false;
		}


		//  Cojemos la traduccion del espacio al idioma seleccionado
		const espacioIdioma = this.espacioSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		espacioIdioma.Nombre = this.espacioSeleccionado.Nombre;
		espacioIdioma.Descripcion = this.espacioSeleccionado.Descripcion;
		this.espacioSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, espacioIdioma);
	}

	public esEdicion(): boolean {
		this.nombreError = false;
		return this.edicion;
	}

	public validar(): boolean {
		this.inputChanged('obligatorio');

		if (this.nombreError || this.fAltaError || this.pantallaPrincipalError) {
			this.msgs.push({ severity: 'error',  detail: this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO') });

		}

		if (this.imagenError) {
			this.msgs.push({ severity: 'error', summary: this.translate.instant('Formularios.imagenobligatoria'), detail: this.translate.instant('Formularios.debeelegirimagen') });
		}

		this.isValid = !this.nombreError && !this.imagenError;
		return this.isValid;
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion) {
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar() {
		this.confirmacionVisible = false;
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.guardar();
		}
		else if (this.operacion === 'eliminar') {
			this.eliminar();
		}
	}

	cancelar() {
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}


	/* Operaciones */
	public guardar = () => {
		if (this.validar()) {

			this.spinner.style.display = 'inherit';

			if (!this.esEdicion()) {
				this.guardarNuevo();
			}
			else {
				this.guardarEdicion();
			}

		} else {
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}

	public guardarNuevo = () => {
		const that = this;

		return this.entityManager.newESPACIO()
		.then(function (ESPACIO) {

			ESPACIO.IDIOMAS.forEach(ESPACIO_IDIOMA => {
				const aux = that.espacioSeleccionado.Idiomas.get(ESPACIO_IDIOMA.IDIOMA.Codigo);
				if(aux){
					ESPACIO_IDIOMA.Nombre = aux.Nombre;
					ESPACIO_IDIOMA.Descripcion = aux.Descripcion;
				}
				else{
					const espacioIdioma = that.espacioSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
					if(espacioIdioma){
						ESPACIO_IDIOMA.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
						ESPACIO_IDIOMA.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';
					}

				}
			});

			const espacioIdioma = that.espacioSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.espacioSeleccionado.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			that.espacioSeleccionado.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

			ESPACIO.Nombre = that.espacioSeleccionado.Nombre;
			ESPACIO.Descripcion = that.espacioSeleccionado.Descripcion;
			ESPACIO.PasswordBeacons = that.espacioSeleccionado.PasswordBeacons;
			ESPACIO.FechaAlta = that.espacioSeleccionado.FechaAlta;
			ESPACIO.FechaBaja = that.espacioSeleccionado.FechaBaja;
			ESPACIO.UbicarAnonimos = that.espacioSeleccionado.UbicarAnonimos;
			ESPACIO.PantallaPrincipal = that.espacioSeleccionado.PantallaPrincipal;

			// Cambiar en el futuro para que sea seleccionable
			ESPACIO.ColorEspacio = that.espacioSeleccionado.ColorEspacio;
			ESPACIO.ColorFuenteEspacio = that.espacioSeleccionado.ColorFuenteEspacio;
			ESPACIO.ColorSeleccionEspacio = that.espacioSeleccionado.ColorSeleccionEspacio;

			that.espacioSeleccionado.ENTIDAD = ESPACIO;

			return that.entityManager.saveChanges();
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function () {
			return that.subirFotos();
		})
		.then(function (fotos) {
			that.espacioSeleccionado.Imagen = that.imagenSeleccionada;
			that.onElementoGuardado.emit(that.espacioSeleccionado);
			return that.espacioSeleccionado;
		})
		.catch(function (e) {
			that.spinner.style.display = 'none';
			that.onElementoError.emit(null);
			return false;
		});
	}
	public guardarEdicion() {
		const that = this;

		// this.espacioSeleccionado.ENTIDAD.IDIOMAS.forEach(ESPACIO_IDIOMA => {
		// 	const aux = that.espacioSeleccionado.Idiomas.get(ESPACIO_IDIOMA.IDIOMA.Codigo);
		// 	ESPACIO_IDIOMA.Nombre = aux.Nombre;
		// 	ESPACIO_IDIOMA.Descripcion = aux.Descripcion;
		// });

		const espacioIdioma = that.espacioSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
		that.espacioSeleccionado.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
		that.espacioSeleccionado.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

		this.espacioSeleccionado.ENTIDAD.Nombre = this.espacioSeleccionado.Nombre;
		this.espacioSeleccionado.ENTIDAD.Descripcion = this.espacioSeleccionado.Descripcion;
		this.espacioSeleccionado.ENTIDAD.PasswordBeacons = this.espacioSeleccionado.PasswordBeacons;
		this.espacioSeleccionado.ENTIDAD.FechaAlta = this.espacioSeleccionado.FechaAlta;
		this.espacioSeleccionado.ENTIDAD.FechaBaja = this.espacioSeleccionado.FechaBaja;
		this.espacioSeleccionado.ENTIDAD.ColorEspacio = this.espacioSeleccionado.ColorEspacio;
		this.espacioSeleccionado.ENTIDAD.ColorFuenteEspacio = this.espacioSeleccionado.ColorFuenteEspacio;
		this.espacioSeleccionado.ENTIDAD.ColorSeleccionEspacio = this.espacioSeleccionado.ColorSeleccionEspacio;
		this.espacioSeleccionado.ENTIDAD.UbicarAnonimos = this.espacioSeleccionado.UbicarAnonimos;
		this.espacioSeleccionado.ENTIDAD.PantallaPrincipal = this.espacioSeleccionado.PantallaPrincipal;
		return this.guardarMultiIdioma()
		.then(function () {
			return that.subirFotos();
		})
		.then(function () {
			return that.entityManager.saveChanges();
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function (msg) {

			if (that.imagenSeleccionada !== undefined && that.imagenSeleccionada !== null) {
				that.espacioSeleccionado.Imagen = that.imagenSeleccionada; // .objectURL;
			}
			that.onElementoGuardado.emit(that.espacioSeleccionado);
			// lo ocultamos en la funcion onElementoGuardado
			return that.espacioSeleccionado;
		})
		.catch(function (err) {
			that.spinner.style.display = 'none';
			return err;
		});

	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.espacioSeleccionado.ENTIDAD.IDIOMAS);

		return this.entityManager.newESPACIO_IDIOMA(this.espacioSeleccionado.ENTIDAD)
		.then(function(ESPACIO_IDIOMAs){

			ESPACIO_IDIOMAs.forEach(ESPACIO_IDIOMA => {
				const aux = that.espacioSeleccionado.Idiomas.get(ESPACIO_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					ESPACIO_IDIOMA.Nombre = aux.Nombre;
					ESPACIO_IDIOMA.Descripcion = aux.Descripcion;
				}

			});
		});

	}

	public eliminar() {
		const that = this;
		this.spinner.style.display = 'inherit';
		this.eliminarSeleccionado()
			.then(function () {
				that.onElementoEliminado.emit(that.espacioSeleccionado);
				that.authService.relogin();

			})
			.catch(function () {
				that.onElementoEliminado.emit(undefined);
			});
	}

	eliminarSeleccionado() {
		const that = this;
		let includes = 'IDIOMAS.IDIOMA, ';
		includes = includes + 'NIVELS.ALAS.SECCIONS.NODOS.CONTENIDOS, ';
		includes = includes + 'RUTAS_SUGERIDA, ';
		includes = includes + 'NOTICIAS, ';
		includes = includes + 'CONTENIDOS, ';
		includes = includes + 'FOTOS';

		const idEspacio = this.espacioSeleccionado.ENTIDAD.Id;

		return this.entityManager.getEspacioById(idEspacio, includes)
		.then(function (espacio) {

			return that.entityManager.deleteESPACIO(espacio);
			// return that.entityManager.saveChanges();
		})
		.catch(function (e) {
			return false;
		});
	}

	public subirFotos() {

		const promises: any[] = [];
		const that = this;

		if (that.imagenSeleccionada !== undefined) {
			/*
			if (that.espacioSeleccionado.ENTIDAD && that.espacioSeleccionado.ENTIDAD.FOTOS) {
				that.entityManager.deleteEntityArray(that.espacioSeleccionado.ENTIDAD.FOTOS);
			}

			promises.push(that.enviarFoto('IdEspacio', that.espacioSeleccionado.ENTIDAD.Id, that.imagenSeleccionada));
			*/
			let idFoto = null;
			if (that.espacioSeleccionado.ENTIDAD && that.espacioSeleccionado.ENTIDAD.FOTOS) {
				const ultima = that.espacioSeleccionado.ENTIDAD.FOTOS.length - 1;
				const fotoUpdate = that.espacioSeleccionado.ENTIDAD.FOTOS[ultima];
				idFoto = fotoUpdate ? fotoUpdate.Id : null;
			}
			promises.push(that.enviarFoto('IdEspacio', that.espacioSeleccionado.ENTIDAD.Id, that.imagenSeleccionada, idFoto));
		}

		return allSettled(promises);
	}

	enviarFoto(entidad, idEntidad, imagen, idFoto = null) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsSubidaFoto(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}
	}

	/* App-Selector_Idioma */
	onIdiomaChange($event) {
		const idioma = $event.value;
		if (idioma) {
			this.idiomaSeleccionado = idioma;

			// Cojemos la traduccion del espacio al idioma seleccionado
			let espacioIdioma = this.espacioSeleccionado.Idiomas.get(idioma.value);

			// Si no existe la creamos
			if (!espacioIdioma) {

				espacioIdioma = new EspacioIdiomaFormulario();

				this.espacioSeleccionado.Idiomas.set(idioma.value, espacioIdioma);

			}

			// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
			this.espacioSeleccionado.Nombre = espacioIdioma.Nombre;
			this.espacioSeleccionado.Descripcion = espacioIdioma.Descripcion;

			console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
		}
	}


/* Image Cropper */
fileChangeListener($event) {
	this.imageCropperVisible = true;
	const image: any = new Image();
	const file: File = $event.target.files[0];
	const nombre = file.name;
	const tipo = file.type;
	const myReader: FileReader = new FileReader();
	const that = this;
	myReader.onloadend = function (loadEvent: any) {
		image.src = loadEvent.target.result;
		that.cropper.setImage(image);
		that.imagenSeleccionada = that.sws.base64ToFile(image.src, nombre, tipo)
		.then(function(fotoFile){
			that.imagenSeleccionada = fotoFile;
		});
	};
	myReader.readAsDataURL(file);
}

asignarFotoCropp($event){
	const that = this;
	that.imagenSeleccionada = this.sws.base64ToFile(this.data.image, that.imagenSeleccionada.name)
	.then(function(fotoFile){
		that.imagenSeleccionada = fotoFile;
		that.imageCropperVisible = false;
	});
}


	/* PIPETA */
	/*
	seleccionPipeta(){
		this.setEyedropSelected(true);
	}
*/
	public onColorChange($event){
		console.log($event);
	}

	public getColor(campo){
		if (campo === 'ColorEspacio') {
			return this.espacioSeleccionado.ColorEspacio;
		}
		if (campo === 'ColorFuenteEspacio') {
			return this.espacioSeleccionado.ColorFuenteEspacio;
		}
		if (campo === 'ColorSeleccionEspacio') {
			return this.espacioSeleccionado.ColorSeleccionEspacio;
		}
	}

	public setColor(_color, campo){

		const colors = _color.match(/\d+/g);
		let  alfa = '1';
		if ( colors.length < 3 )	{
			return;
		}

		if(colors[3] !== undefined){
			alfa = colors[3] + (colors[4] !== undefined ? '.' + colors[4] : '' );
		}

		_color = 'rgba(' + colors[0] + ',' + colors[1] + ',' + colors[2] + ',' + alfa + ')';

		if (campo === 'ColorEspacio') {
			this.espacioSeleccionado.ColorEspacio = _color;
		}
		if (campo === 'ColorFuenteEspacio') {
			this.espacioSeleccionado.ColorFuenteEspacio = _color;
		}
		if (campo === 'ColorSeleccionEspacio') {
			this.espacioSeleccionado.ColorSeleccionEspacio = _color;
		}
	}
	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaAlta') {
			this.espacioSeleccionado.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.espacioSeleccionado.FechaBaja = fecha;
		}
		calendar.overlayVisible=false;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioEspacio.component.ts